(function (app) {
    //Amplitude service used for sending custom event properties in Portal to Amplitude
    app
        .factory("amplitudeService", ['$q', 'featureToggleService', '$transitions', '$state', 'permissionService', 'homeApi',

            function amplitudeService($q, featureToggleService, $transitions, $state, permissionService, homeApi) {
                var service = {
                    logClickEvent: logClickEvent,
                    logCustomEvent: logCustomEvent,
                    setupNavigation: setupNavigation,
                    logUserProperties: logUserProperties,
                    logUserId: logUserId
                };

                var environment = featureToggleService.checkEnv() || 'Undefined Environment';

                var eventTypeList = {
                    click: 'Click',
                    navigation: 'Navigation'
                };

                return service;

                function _testLog(eventType, data_obj) {
                    if (environment !== 'prod') {
                        console.log(eventType, data_obj);
                    }
                }

                //Get current user's properties & pass to Amplitude
                //Keep this in this service so we can access this from the AmplitudeSetup file
                function logUserProperties(userProperties) {
                    var defaultProperties = {
                        environment: environment,
                        hasElevate: permissionService.hasOnePermission('Elevate:Access') ? true : false,
                        hasElevateForLife: permissionService.hasOnePermission('ElevateForLife:Access') ? true : false,
                        hasEitherElevate: permissionService.hasOnePermission('ElevateForLife:Access|Elevate:Access') ? true : false
                    };

                    if (userProperties) {
                        userProperties = Object.assign(userProperties, defaultProperties)
                    } else {
                        userProperties = defaultProperties;
                    }

                    amplitude.getInstance().setUserProperties(userProperties);
                }

                //Get current user's FigAuth ID & pass to Amplitude
                //Keep this in this service so we can access this from the AmplitudeSetup file
                function logUserId() {
                    var onBehalfOfUserId = permissionService.getOnBehalfOfUserId();
                    if (onBehalfOfUserId) {
                        homeApi.getUserFigAuth(onBehalfOfUserId).then(function (response) {
                            amplitude.getInstance().setUserId(response.FigAuthUserId);
                        });
                    } else {
                        homeApi.getUserInfo().then(function (portalUser) {
                            homeApi.getUserFigAuth(portalUser.Id).then(function (response) {
                                amplitude.getInstance().setUserId(response.FigAuthUserId);
                            });
                        });
                    }
                }

                //Generate event & pass to Amplitude

                function _sendEvent(eventType, clickTarget, eventObj) {
                    var data_obj = Object.assign({
                        click_target: clickTarget || 'Undefined Click Target',
                        current_state: $state.current.name,
                        environment: environment,
                        origin: 'portal'
                    }, eventObj);

                    var promises = [];
                    console.log(data_obj);
                    //Run checks on user properties & ID in case of delegates & on behalf of
                    promises.push(logUserProperties());
                    promises.push(logUserId());
                    return $q.all(promises).then(function () {
                        amplitude.getInstance().logEvent(eventType, data_obj, _testLog(eventType, data_obj));
                    });
                }

                function logClickEvent(clickTarget) {
                    _sendEvent(eventTypeList.click, clickTarget, false);
                }

                function logCustomEvent(eventType, clickTarget, eventObj) {
                    _sendEvent(eventType, clickTarget, eventObj);
                }

                //Generate event & pass to Amplitude
                function setupNavigation() {
                    $transitions.onSuccess({}, function (transition) {
                        var to = transition.to();
                        var from = transition.from();

                        if (to.name !== from.name) {
                            _sendEvent(eventTypeList.navigation, false, {
                                from_state: from.name,
                                to_state: to.name
                            });
                        }
                    });
                }

            }
        ])
        .directive("amplitudeEvent", ["amplitudeService", function (amplitudeService) {
            return {
                restrict: 'A',
                scope: {
                    ampEventType: "@",
                    ampPropertyName: "@",
                    ampEventObject: "="
                },

                link: function link(scope, elem) {
                    elem.bind('click', function () {
                        if (scope.ampEventType === 'Click') {
                            amplitudeService.logClickEvent(scope.ampPropertyName);
                        }
                        else {
                            amplitudeService.logCustomEvent((typeof scope.ampEventType === "undefined" || scope.ampEventType === null) ? "Click" : scope.ampEventType, scope.ampPropertyName, scope.ampEventObject);
                        }
                    });
                }
            };
        }]);
})(window.app);